import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { logSafeErrorWithoutCustomerDataWrapper } from '@atlassian/jira-polaris-lib-errors/src/common/utils/index.tsx';

export const logError = (errorSubject: string, error: Error) => {
	const ERROR_ID = 'polaris-error';

	fireErrorAnalytics({
		meta: {
			id: ERROR_ID,
			teamName: 'polaris',
		},
		attributes: {
			subject: errorSubject,
		},
		error,
	});
	logSafeErrorWithoutCustomerDataWrapper(`${ERROR_ID}.${errorSubject}`, error.message, error);
};

export const isPendoReady = (): boolean =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window?.pendo?.isReady && typeof window.pendo.isReady === 'function' && window.pendo.isReady();
